import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Field as FormikField } from 'formik';
import { get } from 'lodash';
import { InputWrapper } from './styles';
import Message from './message';
import Input from './input';

const Field = forwardRef(
  ({ type, name, helpText, required, className, ...rest }, ref) => (
    <InputWrapper className={className}>
      <FormikField name={name}>
        {({ form, meta }) => {
          const { touched, submitCount } = meta;
          const { status } = form;
          const error = meta.error || get(status, `errors.${name}`); // server-side error

          return (
            <Input
              name={name}
              type={type}
              required={required}
              {...rest}
              ref={ref}
              aria-describedby={
                error && (touched || submitCount > 0) ? `${name}_error` : null
              }
            />
          );
        }}
      </FormikField>
      <Message name={name} id={`${name}_error`} helpText={helpText} />
    </InputWrapper>
  )
);

Field.displayName = 'Field';

export const FieldPropTypes = {
  type: PropTypes.oneOf([
    'text-field',
    'auto-suggest',
    'text-area',
    'postcode',
    'email',
    'number',
    'radio-buttons',
    'checkboxes',
    'phone-number',
    'phone-number-(international)',
    'dropdown',
    'search',
  ]).isRequired,
  label: PropTypes.string,
  description: PropTypes.object,
  labelSize: PropTypes.oneOf(['heading', 'standard']),
  fieldWidth: PropTypes.oneOf(['standard', 'small']),
  name: PropTypes.string,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  required: PropTypes.bool,
  /** Should the "(optional)" text be displayed if field is not required? */
  hideOptionalMessage: PropTypes.bool,
  labelHiddenText: PropTypes.string,
};

Field.propTypes = FieldPropTypes;

export default Field;
